import React from 'react';
import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';

import { getNameInCurrentLanguage } from 'helpers/intl';

import IntlFormInlineSelector from 'components/intlForm/IntlFormInlineSelector';

import CategoryAttributeGroupAttribute from 'components/layout/item/CategoryAttributeGroupAttribute';

const attributeGroupSource = {
  beginDrag(props, monitor, component) {
    return {
      type: 'attributeGroup',
      index: props.index,
    };
  },
};

const attributeGroupTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const dragType = monitor.getItem().type;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragType == 'attributeGroup' && dragIndex === hoverIndex) {
      return;
    }

    if (dragType == 'attribute') {
      if (!props.data.getAttributes().length) {
        // the attribute group is empty, we need to accept this attribute
        props.moveAttribute(dragIndex, monitor.getItem().group, props.data.getId(), props.attributeIndexCounter);

        monitor.getItem().index =
          monitor.getItem().group === null ? props.attributeIndexCounter - 1 : props.attributeIndexCounter;
        monitor.getItem().group = props.data.getId();
      }

      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    props.moveAttributeGroups(dragIndex, hoverIndex);

    monitor.getItem().index = hoverIndex;
  },
};

@DropTarget(['attribute', 'attributeGroup'], attributeGroupTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}))
@DragSource('attributeGroup', attributeGroupSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
}))
export default class CategoryAttributeGroup extends React.Component {
  removeAttribute(attribute, groupId) {
    if (this.props.removeAttribute) {
      this.props.removeAttribute(attribute, groupId);
    }
  }
  removeGroup = (e, groupId) => {
    e.preventDefault();

    const { removeGroup } = this.props;
    if (removeGroup) {
      removeGroup(groupId);
    }
  };
  render() {
    const { isDragging, connectDragSource, connectDragPreview, connectDropTarget } = this.props;
    const { appIntl, messages, data } = this.props;

    // continue with index counter
    let attributeIndexCounter = this.props.attributeIndexCounter;

    //console.log(data)

    return connectDropTarget(
      connectDragPreview(
        <div class="bg-master-lightest padding-30 b-rad-lg m-b-15">
          <div class="clearfix">
            <h4 class="pull-left">
              {connectDragSource(<i class="fa fa-drag-handle m-r-10" />)}

              <IntlFormInlineSelector />
              {getNameInCurrentLanguage(data.getAttributeGroup().getName(), appIntl)}
            </h4>
            <h4 class="pull-right">
              <a
                href="#remove"
                class="text-danger m-r-10"
                onClick={e => this.removeGroup(e, data.getAttributeGroup().getId())}
              >
                <i class="fal fa-trash-alt" />
              </a>
            </h4>
          </div>
          <div class="m-t-10">
            {data.getAttributes().map((attribute, i) => {
              //console.log(attribute)
              return (
                <CategoryAttributeGroupAttribute
                  name={getNameInCurrentLanguage(attribute.getAttribute().getName(), appIntl)}
                  group={data.getAttributeGroup().getId()}
                  moveAttribute={this.props.moveAttribute}
                  removeAttribute={() => this.removeAttribute(attribute, data.getAttributeGroup().getId())}
                  messages={messages}
                  index={attributeIndexCounter++}
                  key={i}
                />
              );
            })}
          </div>
        </div>
      )
    );
  }
}
